export const navLinks = [
  { id: 'gallery', label: '图片资源' },
  { id: 'videos', label: '视频内容' },
  { id: 'benefits', label: '会员福利' },
  { id: 'share', label: '会员分享' },
  { id: 'faq', label: '常见问题' },
];

export const heroHighlights = [
  { icon: 'ri-image-2-line', label: '图片资源', value: '12,800+ 张' },
  { icon: 'ri-play-circle-line', label: '视频内容', value: '3,400+ 条' },
  { icon: 'ri-vip-crown-2-line', label: '会员福利', value: '每周更新' },
];

export const offerItems = [
  {
    icon: 'ri-image-2-line',
    title: '精选图片资源',
    desc: '按壁纸、摄影、插画与设计素材分类整理，每张图片保留来源标注与适用场景说明，方便快速取用。',
    tags: ['壁纸', '摄影', '插画'],
  },
  {
    icon: 'ri-play-circle-line',
    title: '视频内容库',
    desc: '收录生活记录、创作教程与影像短片，标注时长、主题与观看热度，帮助你有方向地挑选内容。',
    tags: ['生活记录', '创作教程', '影像短片'],
  },
  {
    icon: 'ri-vip-crown-2-line',
    title: '会员专属福利',
    desc: '会员可优先获取高清新图、合集打包、更新提醒与整理好的专题清单，福利内容持续补充。',
    tags: ['高清原图', '合集打包', '更新提醒'],
  },
  {
    icon: 'ri-share-forward-line',
    title: '会员分享社区',
    desc: '会员可以提交自己整理的资源清单、使用心得与拍摄经验，经整理后分享给更多社区成员。',
    tags: ['资源清单', '使用心得', '拍摄经验'],
  },
];

export const galleryCategories = ['全部', '壁纸', '摄影', '插画', '设计素材'];

export const galleryItems = [
  {
    id: 'g1',
    title: '暖阳渐变抽象壁纸',
    category: '壁纸',
    desc: '流动的琥珀色与暖黄色波纹，适合手机与桌面背景，阅读文字时不抢视线。',
    meta: '3840 × 2160 · 高清',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20soft%20gradient%20wallpaper%20with%20flowing%20amber%20and%20warm%20yellow%20waves%2C%20gentle%20grain%20texture%2C%20minimal%20modern%20art%2C%20calm%20warm%20tones%2C%20clean%20smooth%20background%2C%20elegant%20soothing%20visual%2C%20high%20detail&width=600&height=600&seq=banana-gallery-01&orientation=squarish',
  },
  {
    id: 'g2',
    title: '热带芭蕉叶墙面',
    category: '壁纸',
    desc: '芭蕉叶在奶油色墙面上的柔和投影，适合营造自然放松的居家与办公氛围。',
    meta: '2560 × 1440 · 高清',
    image:
      'https://readdy.ai/api/search-image?query=Minimal%20tropical%20banana%20leaves%20on%20a%20warm%20cream%20wall%20with%20soft%20natural%20sunlight%20and%20gentle%20shadows%2C%20calm%20botanical%20wallpaper%2C%20warm%20yellow%20green%20palette%2C%20clean%20simple%20background%2C%20editorial%20interior%20photography&width=600&height=600&seq=banana-gallery-02&orientation=squarish',
  },
  {
    id: 'g3',
    title: '午后香蕉园小径',
    category: '摄影',
    desc: '阳光穿过枝叶的旅行摄影，记录热带种植园的通透光影，适合做主题封面。',
    meta: '4000 × 3000 · 原图',
    image:
      'https://readdy.ai/api/search-image?query=Sunny%20tropical%20banana%20plantation%20pathway%20with%20lush%20green%20leaves%20and%20warm%20golden%20afternoon%20light%2C%20travel%20lifestyle%20photography%2C%20soft%20bokeh%2C%20warm%20inviting%20atmosphere%2C%20clean%20natural%20composition&width=600&height=600&seq=banana-gallery-03&orientation=squarish',
  },
  {
    id: 'g4',
    title: '清晨水果早餐桌',
    category: '摄影',
    desc: '木桌上的香蕉与早餐碗，暖调食物摄影，光线柔和，适合做美食与生活方式配图。',
    meta: '3600 × 2700 · 原图',
    image:
      'https://readdy.ai/api/search-image?query=Fresh%20ripe%20bananas%20and%20healthy%20breakfast%20bowl%20on%20a%20rustic%20wooden%20table%2C%20warm%20morning%20light%2C%20cozy%20food%20photography%2C%20soft%20shadows%2C%20simple%20warm%20background%2C%20appetizing%20clean%20composition&width=600&height=600&seq=banana-gallery-04&orientation=squarish',
  },
  {
    id: 'g5',
    title: '社区共创插画',
    category: '插画',
    desc: '扁平风插画，描绘成员一起整理与分享内容，暖黄配清新绿，可用作栏目头图。',
    meta: '3000 × 3000 · 矢量',
    image:
      'https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20cheerful%20people%20sharing%20creative%20content%20together%2C%20warm%20yellow%20and%20green%20color%20palette%2C%20soft%20rounded%20shapes%2C%20minimal%20modern%20illustration%2C%20clean%20simple%20background%2C%20friendly%20warm%20mood&width=600&height=600&seq=banana-gallery-05&orientation=squarish',
  },
  {
    id: 'g6',
    title: '香蕉吉祥物形象',
    category: '插画',
    desc: '手持相机的香蕉吉祥物，风格轻快可爱，适合用作会员专区与更新提示的形象。',
    meta: '2400 × 2400 · 矢量',
    image:
      'https://readdy.ai/api/search-image?query=Cute%20flat%20illustration%20of%20a%20happy%20mascot%20banana%20character%20holding%20a%20camera%2C%20pastel%20warm%20yellow%20and%20green%20tones%2C%20minimal%20modern%20design%2C%20clean%20plain%20background%2C%20playful%20friendly%20style%2C%20soft%20rounded%20shapes&width=600&height=600&seq=banana-gallery-06&orientation=squarish',
  },
  {
    id: 'g7',
    title: '热带几何纹样',
    category: '设计素材',
    desc: '可无缝拼接的几何纹样，用于包装、布料与页面底纹，黄绿配色统一耐看。',
    meta: '可商用 · 无缝拼接',
    image:
      'https://readdy.ai/api/search-image?query=Seamless%20geometric%20pattern%20with%20warm%20yellow%20and%20green%20tropical%20motifs%2C%20minimal%20modern%20textile%20design%2C%20clean%20cream%20background%2C%20balanced%20repeating%20shapes%2C%20soft%20harmonious%20colors%2C%20elegant%20surface%20design&width=600&height=600&seq=banana-gallery-07&orientation=squarish',
  },
  {
    id: 'g8',
    title: '柔光纸张纹理',
    category: '设计素材',
    desc: '细腻的纸张颗粒质感，适合做背景与卡片底纹，叠加文字后依然清晰易读。',
    meta: '可商用 · 高分辨率',
    image:
      'https://readdy.ai/api/search-image?query=Soft%20paper%20texture%20background%20in%20warm%20cream%20and%20soft%20yellow%20tones%2C%20subtle%20grain%20and%20gentle%20light%2C%20minimal%20stationery%20backdrop%2C%20clean%20simple%20composition%2C%20elegant%20calm%20surface%20design&width=600&height=600&seq=banana-gallery-08&orientation=squarish',
  },
];

export const videoItems = [
  {
    id: 'v1',
    title: '一周生活记录：把日常拍成暖色调',
    category: '生活记录',
    duration: '12:40',
    views: '8.6 万',
    author: '阿柚',
    desc: '从清晨到夜晚的随手记录，讲解如何用自然光与暖色调把普通日常拍得有质感。',
    thumbnail:
      'https://readdy.ai/api/search-image?query=Warm%20cozy%20home%20vlog%20setup%20with%20camera%2C%20microphone%20and%20soft%20yellow%20lighting%20on%20a%20wooden%20desk%2C%20lifestyle%20video%20thumbnail%2C%20clean%20minimal%20composition%2C%20inviting%20warm%20tones%2C%20soft%20shadows&width=640&height=360&seq=banana-video-01&orientation=landscape',
  },
  {
    id: 'v2',
    title: '新手也能上手的视频剪辑入门',
    category: '创作教程',
    duration: '18:05',
    views: '5.2 万',
    author: '木木',
    desc: '拆解剪辑流程：素材整理、节奏把控与配乐选择，跟着做一遍就能出片。',
    thumbnail:
      'https://readdy.ai/api/search-image?query=Flat%20illustration%20of%20video%20play%20concept%20with%20warm%20yellow%20and%20green%20shapes%2C%20modern%20minimal%20graphic%2C%20clean%20cream%20background%2C%20friendly%20creative%20style&width=640&height=360&seq=banana-video-02&orientation=landscape',
  },
  {
    id: 'v3',
    title: '水果早餐的三种拍法',
    category: '影像短片',
    duration: '06:22',
    views: '3.9 万',
    author: '小柠',
    desc: '同一份早餐，用俯拍、侧光与特写三种方式呈现，对比不同构图带来的观感差异。',
    thumbnail:
      'https://readdy.ai/api/search-image?query=Fresh%20healthy%20tropical%20fruit%20flat%20lay%20with%20bananas%20on%20marble%20surface%2C%20bright%20warm%20light%2C%20clean%20food%20videography%20thumbnail%2C%20minimal%20composition&width=640&height=360&seq=banana-video-03&orientation=landscape',
  },
  {
    id: 'v4',
    title: '旅拍选片与调色思路',
    category: '创作教程',
    duration: '15:48',
    views: '4.5 万',
    author: '海盐',
    desc: '围绕一次海边旅拍，分享选题、选片标准与统一色调的处理方式，适合进阶练习。',
    thumbnail:
      'https://readdy.ai/api/search-image?query=Travel%20vlog%20scene%20of%20a%20sunny%20tropical%20beach%20with%20warm%20golden%20light%2C%20cinematic%20thumbnail%2C%20clean%20simple%20composition%2C%20inviting%20vacation%20mood&width=640&height=360&seq=banana-video-04&orientation=landscape',
  },
];

export const benefitItems = [
  {
    icon: 'ri-download-2-line',
    title: '高清原图下载',
    desc: '会员可直接获取高分辨率原图与无压缩版本，省去二次处理的时间。',
    detail: '涵盖壁纸、摄影与设计素材三大类，下载文件保留原始尺寸与色彩信息。',
  },
  {
    icon: 'ri-folder-zip-line',
    title: '合集打包领取',
    desc: '按主题整理的资源合集，一次打包领取，避免逐个查找。',
    detail: '每个合集附一份清单说明，标注分类、数量与适用场景，便于归档。',
  },
  {
    icon: 'ri-notification-3-line',
    title: '更新优先提醒',
    desc: '新资源上线时优先推送，先人一步看到最新内容。',
    detail: '可按关注的主题订阅提醒，只接收自己感兴趣的分类更新。',
  },
  {
    icon: 'ri-bookmark-3-line',
    title: '专题清单订阅',
    desc: '围绕季节、节日与热点整理的专题清单，持续更新。',
    detail: '专题清单由编辑与会员共同整理，内容会随讨论不断补充。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '使用答疑支持',
    desc: '遇到下载或使用问题，可在社区内提问并获得解答。',
    detail: '常见问题收录在答疑专区，复杂问题会由社区成员协助排查。',
  },
  {
    icon: 'ri-user-star-line',
    title: '分享优先展示',
    desc: '会员提交的分享有机会被推荐到首页与专题区。',
    detail: '优质分享会注明作者，并加入对应分类的精选列表。',
  },
];

export const memberShares = [
  {
    name: '阿柚',
    role: '生活方式创作者',
    meta: '加入 14 个月',
    content:
      '最喜欢的是分类做得很清楚，找壁纸不用再翻很多页。每周的更新提醒也很克制，不会刷屏，需要的时候才看。',
  },
  {
    name: '木木',
    role: '视频剪辑爱好者',
    meta: '加入 9 个月',
    content:
      '教程模块对我帮助很大，尤其是选片思路那一期，看完之后整理素材的效率明显提高了。',
  },
  {
    name: '小柠',
    role: '美食摄影玩家',
    meta: '加入 1 年',
    content:
      '合集打包很省心，下载下来就是一个完整主题。清单说明写得很细，直接按分类归档就能用。',
  },
  {
    name: '海盐',
    role: '旅拍爱好者',
    meta: '加入 7 个月',
    content:
      '会员专区的高清原图质量很稳，调色参考价值高。有问题在社区提问，基本都能得到回复。',
  },
  {
    name: '南风',
    role: '平面设计师',
    meta: '加入 11 个月',
    content:
      '设计素材的纹样和纹理都能直接用在项目里，配色统一，省去了很多找素材的时间。',
  },
  {
    name: '秋栗',
    role: '内容运营',
    meta: '加入 6 个月',
    content:
      '分享社区的讨论氛围不错，看到别人整理的清单也会跟着补充，慢慢就攒出了自己的资源库。',
  },
];

export const communityStats = [
  { value: '12,800+', label: '图片资源累计整理', icon: 'ri-image-2-line' },
  { value: '3,400+', label: '视频内容收录', icon: 'ri-play-circle-line' },
  { value: '26,000+', label: '注册会员', icon: 'ri-group-line' },
  { value: '每周 3 次', label: '资源更新频率', icon: 'ri-refresh-line' },
];

export const faqItems = [
  {
    q: '香蕉社区主要提供哪些内容？',
    a: '社区围绕图片、视频与会员分享三类内容展开：图片按壁纸、摄影、插画和设计素材分类整理；视频涵盖生活记录、创作教程与影像短片；会员分享则是成员提交的资源清单与使用心得。',
  },
  {
    q: '非会员可以浏览内容吗？',
    a: '可以。分类浏览、内容简介与专题清单对所有人开放；高清原图下载、合集打包、更新优先提醒等属于会员福利，需要成为会员后使用。',
  },
  {
    q: '会员福利多久更新一次？',
    a: '资源总体保持每周 3 次左右的更新节奏，专题清单会随主题推进陆续补充。具体更新以社区内的更新说明为准。',
  },
  {
    q: '怎么参与会员分享？',
    a: '你可以在分享社区提交自己整理的资源清单、使用心得或拍摄经验，经编辑整理后会展示在对应分类中，并注明作者。',
  },
  {
    q: '资源可以用于个人项目吗？',
    a: '用于个人学习与练习一般没有问题。如需用于商业用途，请查看素材标注的授权说明，并以说明为准。',
  },
  {
    q: '遇到使用问题怎么办？',
    a: '可以先查看常见问题与答疑专区；若仍未解决，可在社区内提问，会有成员与编辑协助排查。',
  },
];

export const footerLinks = [
  {
    title: '内容导航',
    links: [
      { label: '图片资源', id: 'gallery' },
      { label: '视频内容', id: 'videos' },
      { label: '会员分享', id: 'share' },
    ],
  },
  {
    title: '会员相关',
    links: [
      { label: '会员福利', id: 'benefits' },
      { label: '社区数据', id: 'stats' },
      { label: '常见问题', id: 'faq' },
    ],
  },
  {
    title: '关于社区',
    links: [
      { label: '社区概览', id: 'overview' },
      { label: '加入社区', id: 'join' },
    ],
  },
];